import { Grid, Typography } from "@mui/material";
import React, { useMemo } from "react";

import AdvancedTradeInputs from "./AdvancedTradeInputs";
import { BadgeShape } from "./AdvancedTradeInputs/TradeInput";
import { TRADE_SIDE } from "pages/BasicTrade/components/constants";
import TradeTypeTabs from "./TradeTypeTabs";
import WalletTypeTabs from "./WalletTypeTabs";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

function AdvancedTradeForm({ handleGetWalletInfo }) {
  const { source } = useParams();
  const tradeInitial = useSelector((state) => state.trade.tradeInitial?.data);

  const sourceCoin = useMemo(() => {
    return tradeInitial?.lisCoin?.find((coin) => coin?.id === +source);
  }, [source, tradeInitial?.lisCoin]);

  return (
    <Grid container mt={2} p={1} spacing={1}>
      <WalletTypeTabs />

      <TradeTypeTabs />

      <Grid item xs={12}>
        {sourceCoin?.extraUnitComment && (
          <Grid item xs={12}>
            <BadgeShape>
              <Typography
                textAlign="center"
                variant="subtitle1"
                fontWeight={500}
                color="text.main"
              >
                {sourceCoin?.extraUnitComment}
              </Typography>
            </BadgeShape>
          </Grid>
        )}
      </Grid>

      <Grid item xs={6}>
        <AdvancedTradeInputs
          sideId={TRADE_SIDE.Buy.id}
          handleGetWalletInfo={handleGetWalletInfo}
        />
      </Grid>

      <Grid item xs={6}>
        <AdvancedTradeInputs
          sideId={TRADE_SIDE.Sell.id}
          handleGetWalletInfo={handleGetWalletInfo}
        />
      </Grid>
    </Grid>
  );
}

export default AdvancedTradeForm;
